



















































import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import { HeaderInfo } from '@/contracts/Settings'
import Cookie from '@/components/Cookie'
import SurveyButton from '@/components/SurveyButton.vue'
import ButtonBuyOnline from '@/components/ButtonBuyOnline'
import PopupCityList from '@/components/PopupCityList.vue'
import SelectCityForm from '@/components/new-design/SelectCityForm.vue'
import BlockListSeoCities from '@/components/BlockListSeoCities.vue'
import Notifications from '@/components/new-design/Notifications.vue'
import HeaderNavMenuSsronly from '@/components/Ssr/HeaderNavMenuSsronly.vue'
import AuthModal from '@/components/AuthModal.vue'
import AuthAccountModal from '@/components/AuthAccountModal/AuthAccountModal.vue'
import NavigationModal from '@/components/NavigationModal.vue'
import MobileAppBanner from '@/components/MobileAppBanner.vue'
import PopupOldPage from '@/components/PopupOldPage.vue'
import { useRegistry } from '@/composition/useRegistry'

export default defineComponent({
  name: 'LayoutBlocks',
  components: {
    MobileAppBanner,
    AuthModal,
    AuthAccountModal,
    NavigationModal,
    Notifications,
    HeaderNavMenuSsronly,
    BlockListSeoCities,
    SelectCityForm,
    PopupCityList,
    PopupReviewDetail: () => import('@/components/PopupReviewDetail.vue'),
    Cookie,
    ButtonBuyOnline,
    PopupOldPage,
    BlockPopupFaq: () => import('@/components/BlockPopupFaq.vue'),
    SurveyButton,
    SurveyPopup: () => import('@/components/SurveyPopup.vue'),
  },
  setup() {
    const store = useStore()

    const registry = useRegistry()

    const headerInfo = computed(
      () => store.getters['settings/headerInfo'] as HeaderInfo
    )
    const showReviewDetailPopup = computed<boolean>(
      () => store.getters['popupReviewDetail/getShowPopupDetail']
    )
    const openReviewDetailPopup = computed<boolean>(
      () => store.getters['popupReviewDetail/getOpenPopupDetail']
    )
    const reviewDetail = computed(
      () => store.getters['popupReviewDetail/getReview']
    )
    const showSearchBot = computed(
      () => store.getters['popupSearchBot/getIsShown']
    )

    const closePopup = (event: Event) => {
      const { target }: { target: EventTarget | null } = event
      if (target && target.closest('a')) {
        store.commit('popupBuyOnline/TOGGLE_FAQ_POPUP')
      }
    }
    const closePopupReviewDetailHandle = () => {
      store.commit('popupReviewDetail/SET_OPEN_POPUP_DETAIL', false)
    }
    const closeSearchPopup = () => {
      store.commit('popupSearchBot/SET_IS_SHOWN', false)
    }

    const surveyState = computed(() => store.getters['settings/survey'])
    const hideSurveyBtn = computed(
      () => store.getters['settings/getHideSurveyBtn']
    )

    return {
      showSearchBot,
      headerInfo,
      closePopup,
      closePopupReviewDetailHandle,
      closeSearchPopup,
      surveyState,
      hideSurveyBtn,
      reviewDetail,
      showReviewDetailPopup,
      openReviewDetailPopup,

      registry,
    }
  },
})
